/*
 * Portal video cards: swap the poster for the player on demand.
 *
 * Every stage is a real link to the video on YouTube — that is the whole
 * behaviour before this file runs, and it stays the behaviour for a modified
 * click asking for a new tab. A plain click is upgraded: the poster and the
 * play button leave, a youtube-nocookie iframe takes the stage, autoplaying
 * because the visitor has just pressed play. Nothing from Google is on the
 * page until then.
 *
 * Delegated from the document rather than wired per card, so cards the theme
 * editor inserts after load need no second pass, and one listener serves
 * every portal band on the page.
 */

const STAGE = 'a[data-pp-video-id]';

/* youtube-nocookie keeps the visit out of the viewer's YouTube history until
 * they actually play; rel=0 keeps the end screen to this channel's videos. */
const embedURL = (id) =>
  `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;

/** @param {HTMLAnchorElement} stage */
const loadPlayer = (stage) => {
  const id = stage.dataset.ppVideoId || '';
  if (!id) return;

  const frame = document.createElement('iframe');
  frame.className = 'pp-portal-video__frame';
  frame.src = embedURL(id);
  frame.title = stage.dataset.ppVideoTitle || 'Video';
  frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  frame.allowFullscreen = true;

  /*
   * The anchor is replaced rather than filled: an iframe inside a link would
   * hand every click inside the player back to the link, and the link's job
   * — reaching the video without this file — is done the moment the player
   * is here. The classes carry the drawn stage over.
   */
  const box = document.createElement('div');
  box.className = 'pp-portal-video__stage';
  box.append(frame);
  stage.replaceWith(box);
};

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target || event.defaultPrevented || event.button !== 0) return;
  // A modified click is asking for a new tab, which the link already serves.
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const stage = target.closest(STAGE);
  if (!(stage instanceof HTMLAnchorElement)) return;

  event.preventDefault();
  loadPlayer(stage);
});
